import React from 'react';

import KiloSelect from 'components/KiloSelect';

export const ALL_STATUSES = 'all';

const OPTIONS = [
  { value: ALL_STATUSES, label: 'All Statuses' },
  { value: 'completed', label: 'Completed' },
  { value: 'almost_done', label: 'Almost Done' },
  { value: 'in_progress', label: 'In Progress' },
];

interface IClubStatusFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const ClubStatusFilter = ({ value, onChange }: IClubStatusFilterProps): JSX.Element => (
  <KiloSelect
    label='Club Status'
    data={OPTIONS}
    value={value}
    onChange={selected => onChange(selected ?? ALL_STATUSES)}
    allowDeselect={false}
    w={180}
  />
);

export default ClubStatusFilter;
